module.exports = __webpack_public_path__ + "static/media/mn5.ed903814.jpeg";